const rules = {
    required: value => (!!value && value.trim().length > 0) || "Required",
    checkboxRequired: value => value || "Required",
    selectIDRequired: value => {
        return !isNaN(parseInt(value)) || "Required";
    },
    numeric: value => (!isNaN(parseFloat(value)) && isFinite(value)) || "Must be numeric",
    numericOrEmpty: value => {
        if (!value || value.length <= 0) {
            return true;
        }
        else {
            return (!isNaN(parseFloat(value)) && isFinite(value)) || "Must be numeric";
        }
    },
    nonNegativeNumeric: value => parseFloat(value) >= 0 || "Cannot be a negative number",
    positiveNumericOrEmpty: value => {
        if (value === "0" || value === 0) {
            // these will be false for !value but we need them to be invalidated
        }
        else if (!value || value.length <= 0) {
            return true;
        }

        return parseFloat(value) > 0 || "Must be a positive number or empty";
    },
    max100: value => maxLengthValidationRule(value, 100),
    phoneNumber: value => minLengthValidationRule(value, 10, true, "Invalid phone number"),
    faxNumber: value => minLengthValidationRule(value, 10, true, "Invalid fax number"),
    email: value => {
        if (!value || value.length <= 0){
            return true;
        }
        // taken from https://vuetifyjs.com/en/components/text-fields#example-validation
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail";
    },
    bsb: value => {
        if (!value || value.length <= 0) {
            return true; // empty input is always OK
        }
        else {
            // must be a number and 6 digits in length
            return ((!isNaN(parseFloat(value)) && isFinite(value)) && value.length === 6) || "Must be 6 digits in length";
        }
    }
}

function bsbMask() {
    return "###-###";
}

function phoneMask(value) {
    if (value && value.startsWith("04")) {
        // mask for mobile number
        return "#### ### ###";
    }

    // mask for regular numbers
    return "(##) #### ####";
}

function minLengthValidationRule(value, length, allowEmpty, message) {
    if (value && value.length >= length) {
        return true;
    }

    if(allowEmpty && (!value || value.length == 0)) {
        return true;
    }

    if (message) {
        return message;
    }

    return "Minimum " + length + " characters";
}

function maxLengthValidationRule(value, length, message) {
    if (value && value.length <= length) {
        return true;
    }

    if (message) {
        return message;
    }

    return "Maximum " + length + " characters";
}

export default {
    rules,
    phoneMask,
    bsbMask
}